module.exports = __webpack_public_path__ + "img/spark.a8427430.png";